import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDate',
    standalone: true,
})
export class FormatDatePipe implements PipeTransform {
    transform(value: any): string {
        if (!value) {
            return '';
        }

        return formatDate(value, 'dd/MM/yyyy', 'en');
    }
}
